import { z } from 'zod';

export const emailSchema = z
  .string()
  .trim()
  .min(1, 'Введите email')
  .email('Некорректный email');

// Требования бэка (API.md §signup): ≥ 6 символов, строчная + заглавная буква,
// цифра, спецсимвол. Регулярка — не криптография, а быстрая клиентская
// подсказка; финальная валидация всё равно на сервере.
const PASSWORD_COMPLEXITY =
  /^(?=.*[a-zа-яё])(?=.*[A-ZА-ЯЁ])(?=.*\d)(?=.*[^A-Za-zА-Яа-яЁё0-9]).{6,}$/;

export const signupPasswordSchema = z
  .string()
  .min(6, 'Минимум 6 символов')
  .max(128, 'Слишком длинный пароль')
  .regex(
    PASSWORD_COMPLEXITY,
    'Пароль должен содержать строчную, заглавную буквы, цифру и спецсимвол',
  );

// На логине не проверяем сложность — старые пароли могут быть короче новых
// требований, сервер сам скажет что не так.
export const loginPasswordSchema = z.string().min(1, 'Введите пароль');

export const loginSchema = z.object({
  email: emailSchema,
  password: loginPasswordSchema,
});

export const signupSchema = z.object({
  name: z
    .string()
    .trim()
    .min(2, 'Имя слишком короткое')
    .max(20, 'Максимум 20 символов'),
  email: emailSchema,
  password: signupPasswordSchema,
});

export const restoreSchema = z.object({
  email: emailSchema,
});

export const restoreConfirmSchema = z
  .object({
    code: z
      .string()
      .trim()
      .min(4, 'Введите код из письма')
      .max(12, 'Слишком длинный код'),
    password: signupPasswordSchema,
    passwordRepeat: z.string().min(1, 'Повторите пароль'),
  })
  .refine((data) => data.password === data.passwordRepeat, {
    message: 'Пароли не совпадают',
    path: ['passwordRepeat'],
  });

export type LoginInput = z.infer<typeof loginSchema>;
export type SignupInput = z.infer<typeof signupSchema>;
export type RestoreInput = z.infer<typeof restoreSchema>;
export type RestoreConfirmInput = z.infer<typeof restoreConfirmSchema>;
